import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import  MyListCheck  from '../common/MemberListCheck';
import  PhasesListCheck  from '../common/PhasesListCheck';

export default class ScopeDetailss extends Component {
  static propTypes = {

  };
  state = {
  };


  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Details
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <MyListCheck handleToggle={this.props.handleToggle} members={this.props.members} reviewActive={this.props.reviewActive}></MyListCheck>
          </Grid>
          <Grid item xs={12}>
            <PhasesListCheck handleToggle={this.props.handleTogglePhases} phases={this.props.phases} reviewActive={this.props.reviewActive}></PhasesListCheck>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ScopeDetails.js